import axiosInstance from "./api";
import cache from "../utils/cacheUtil";

const TOOLS_GET_KEY = "tools-get";
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export const toolsService = {
  getAll: async () => {
    const cached = cache.get(TOOLS_GET_KEY);
    if (cached) {
      return cached;
    }

    const result = await axiosInstance.get("/api/tools");

    if (result?.data?.data) {
      cache.set(TOOLS_GET_KEY, result.data.data, {
        mode: "memory",
        absoluteTtl: CACHE_DURATION,
        slidingTtl: CACHE_DURATION / 2,
      });
    }

    return result?.data?.data || [];
  },
};
